import classNames from "classnames";
import CloseIconSvg from "PFIcons/plus_fat.svg";
import React from "react";

import BadgeIcon from "./badge_icon";
import css from "./bottom_card_button.module.scss";

interface IProps {
  count: number;
  expanded: boolean;
  selected: boolean;
  onClick: () => void;
  icon: React.FC;
  className?: string;
}

const CloseIcon = (props) => <CloseIconSvg className={css.closeIcon} {...props} width={35} height={35} />;

const BottomCardButton = ({ count, expanded, selected, onClick, icon, className }: IProps) => {
  const CardIcon = icon;

  return (
    <div className={classNames(css.root, className)}>
      <div className={classNames(css.blobTail, { [css.selected]: selected || !expanded })}>
        <svg viewBox="0 0 100 90" width="200">
          <path d="M0,0V90H50C50,68 60,60 80,60 100,60 100,30 80,30 60,30 50,22 50,0Z" />
        </svg>
      </div>
      <button className={css.button} onClick={onClick}>
        <BadgeIcon
          value={selected ? undefined : count}
          icon={expanded && selected ? <CloseIcon /> : <CardIcon />}
        />
      </button>
    </div>
  );
};

export default BottomCardButton;
